import { useEffect, useRef, useState } from "react";
import { resolveImg, refreshFileToken, variantWidth } from "@/lib/api";

export const initials = (n) =>
  ((n || "").trim().split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase()) || "?";

// Avatar uživatele: fotka, když ji má, jinak iniciály.
//
// Fotky leží v chráněném úložišti a jejich URL se podepisuje na 10 minut
// (`/api/files/…?sig=`). Proto se podpis musí nejdřív připravit (`refreshFileToken`)
// a při vypršení jednou obnovit — holé `<img src={photo_url}>` ukáže rozbitý obrázek.
//
// `size` je v px (kruh i velikost písma iniciál), `className` slouží na barvu
// pozadí/textu iniciál (např. "bg-brand/15 text-brand").
export function Avatar({ name, photo, size = 36, className = "", testid }) {
  const [src, setSrc] = useState(null);
  const tries = useRef(0);

  useEffect(() => {
    let alive = true;
    tries.current = 0;
    setSrc(null);
    // 216: avatar má desítky px — stačí nejmenší náhled ze serveru, ne originál.
    if (photo) refreshFileToken().then(() => { if (alive) setSrc(resolveImg(photo, variantWidth(size))); });
    return () => { alive = false; };
  }, [photo, size]);

  // Vypršelý podpis → jeden pokus o nový. Pak se vzdáme a ukážeme iniciály,
  // ať se to nezacyklí na fotce, která v úložišti opravdu není.
  const onError = async () => {
    if (tries.current >= 1) { setSrc(null); return; }
    tries.current += 1;
    await refreshFileToken(true);
    setSrc(`${resolveImg(photo, variantWidth(size))}&_r=${Date.now()}`);
  };

  return (
    <span data-testid={testid} style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }}
      className={`rounded-full inline-flex items-center justify-center overflow-hidden shrink-0 font-extrabold leading-none ${className}`}>
      {src
        ? <img src={src} alt="" className="w-full h-full object-cover" onError={onError} loading="lazy" decoding="async" />
        : initials(name)}
    </span>
  );
}
